import React from "react";
import StockOverview from "../components/StockOverview/StockOverview";
import { fetchDataList } from "../api";
import { useQuery } from "react-query";
import Spinner from "../components/Spinner/Spinner";

function StockScreener({ title }) {
  const { data, isLoading } = useQuery(["company-overview"], () =>
    fetchDataList("company")
  );

  const firebaseData = React.useMemo(() => {
    if (data) {
      const array = Object.entries(data)?.map((el) => {
        return { ticker: el?.[0], ...el?.[1] };
      });
      return array?.sort((a, b) => {
        const stockOne = a.name.toLowerCase();
        const stockTwo = b.name.toLowerCase();

        if (stockOne < stockTwo) {
          return -1;
        } else if (stockOne > stockTwo) {
          return 1;
        } else {
          return 0;
        }
      });
    }
    return [];
  }, [data]);

  if (isLoading) return <Spinner />;

  return (
    <>
      <h1 className="text-light text-center">{title}</h1>
      <StockOverview data={firebaseData} title={title} />
    </>
  );
}

export default StockScreener;
